export default "__VITE_PUBLIC_ASSET__6c6d0081__"